<template>
  <div id="app" class="full-size">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
    this.$store.commit('setScreenSize');
    this.$store.commit('startUpdateScreeSzie');
  },
}
</script>
<style lang="less">
@import './assets/css/reset.less';
@import './assets/css/global.less';
@import './assets/css/iconfont/iconfont.css';
// #app {
//   // font-family: 'Avenir', Helvetica, Arial, sans-serif;
//   // -webkit-font-smoothing: antialiased;
//   // -moz-osx-font-smoothing: grayscale;
//   // text-align: center;
//   // color: #2c3e50;
// 	// margin-top: 60px;
// 	min-width: 1105px;
// }
</style>



// WEBPACK FOOTER //
// src/App.vue